exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collaboration__logo.movestic {\n  height: 8rem;\n}\n\n.movestic-collaboration {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n", ""]);

// exports
